export default "__VITE_ASSET__B4p5ctd9__"